import {
  AgentSetupBlock,
  type AgentSetupBlockProps,
  AgentSetupCompleteBlock,
  FeatureLabel,
} from 'hooks/dialogs/cluster/components/features';

type SetupProps = Pick<AgentSetupBlockProps, 'checked' | 'onChange'>;

type CompleteProps = {
  checked?: boolean;
};

const heading = 'Compliance';

export const SecurityComplianceSetup = (props: SetupProps) => {
  return (
    <AgentSetupBlock
      heading={heading}
      description="Scan the configuration of the cluster and workloads for deviations from secure configuration compliance."
      checked={props.checked}
      onChange={props.onChange}
      labelChip={<FeatureLabel type="free" />}
      testId="security-compliance"
    />
  );
};

export const SecurityComplianceComplete = ({ checked }: CompleteProps) => {
  return (
    <AgentSetupCompleteBlock
      heading={heading}
      testId="security-compliance-complete"
      checked={checked}
    />
  );
};
